import { render, staticRenderFns } from "./InformationBoard.vue?vue&type=template&id=633966d8&"
import script from "./InformationBoard.vue?vue&type=script&lang=ts&"
export * from "./InformationBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports